function get(obj, path, defaultValue) {
    // 将路径字符串按 '.' 分割成属性数组
    const properties = path.split('.');
    // 遍历属性数组
    for (let prop of properties) {
        // 如果对象为空或属性不存在，则返回默认值
        if (!obj || !obj.hasOwnProperty(prop)) {
            return defaultValue;
        }
        // 更新当前对象为下一个属性的值
        obj = obj[prop];
    }
    // 返回获取的属性值
    return obj;
}

export { get };
